import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, NG_VALIDATORS } from '@angular/forms';
@Directive({
    selector: '[validateEmail][formControlName],[validateEmail][formControl],[validateEmail][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EmailValidatorDirective), multi: true }
    ]
})
export class EmailValidatorDirective implements Validator {
    EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    constructor( @Attribute('validateEmail') public validateEmail: string) {
    }
    validate(c: any): { [key: string]: any } {
        return this.EMAIL_REGEX.test(c.value) ? null : {
            validateEmail: {
                valid: false
            }
        };

    }
}
